export const PRIMENG_YY_MM_DD = 'yy-mm-dd';
export const PRIMENG_YY_MM = 'yy-mm';
